<script setup lang="ts">
import { toRef } from 'vue';

import VFormButtonsGroupWidget from '@modules/form-widgets/components/VFormButtonsGroupWidget/VFormButtonsGroupWidget.vue';

import type { IReportTabsEmits, IReportTabsProps } from './types';
import { useReportTabs } from './composables';

const props = defineProps<IReportTabsProps>();
const emit = defineEmits<IReportTabsEmits>();

const {
  buttons,
  onToggle,
  onRemove,
  onSelectItem,
  onAdd,
} = useReportTabs(
  toRef(props, 'tabs'),
  toRef(props, 'translationKey'),
  toRef(props, 'addNoPointerEvents'),
  emit,
);
</script>

<template>
  <VFormButtonsGroupWidget v-data-qa-auto-id="'VReportTabs'"
    :buttons="buttons"
    :add-label="addLabel"
    :add-icon="addIcon"
    :add-no-pointer-events="addNoPointerEvents"
    :no-gap="noTabsGap"
    @expand-toggle="onToggle"
    @remove="onRemove"
    @select-item="onSelectItem"
    @add="onAdd"
  />
</template>
